import React, {useEffect, useState, useRef} from "react";
import {cqAPI, Auth, getParam, HOST} from "../../lib/Auth";
import ChatComponent from "../ChatComponent/ChatComponent";
import PhoneNumbers from "../PhoneSettings/PhoneNumbers";
import BlockedPhone from "../BlockedPhone/BlockedPhone";
import WhiteList from "../WhiteList/WhiteList";
import PhoneExtensions from "../PhoneSettings/PhoneExtensions";
import RoutesSetting from "../PhoneSettings/Routing/Routes";
import Adapter from "../AdapterSetting/AdapterSetting";
import CallList from "../CallReport/CallReport";
import PaymentList from "../PaymentReport/PaymentReport";
import PaymentRequestList from "../PaymentReport/PaymentRequestReport";
import InstallmentReport from "../PaymentReport/InstallmentReport"
import DiscountReport from "../PaymentReport/DiscountReport"
import CallDetail from "../CallReport/CallDetail";
import Subscription from "../Subscription/Subscription";
import Bundles from "../Subscription/Bundles";
import UserManagement from "../UserManagement/UserManagement";
import AllCustomers from "../Admin/AllCustomers";
import Inbox from "../Inbox/Inbox";
import InboxMessages from "../Inbox/InboxMessages";
import StripeConnect from "../StripeConnect/StripeConnect";
import Invoices from "../Invoices/Invoices";
import Dashboard from "../Dashboard/Dashboard";
import Campaigns from "../Campaigns/Campaigns";
import BookingSettings from "../BookingSettings/BookingSettings"
import NotificationSettings from "../NotificationSettings/NotificationSettings";
import Forms from "../Forms/Forms";
import HistoryTemplate from "../HistorySettings/History";
import EditHistoryTemplate from "../HistorySettings/EditHistory";
import GenericSettings from "../GenericSettings/GenericSettings"
import Information from "../GenericSettings/Information"
import Widget from "../GenericSettings/Widget"
import CustomizeAI from "../GenericSettings/CustomizeAI"
import ChangePassword from "../ChangePassword/ChangePassword";
import ChangePasswordComponent from "../ChangePassword/ChangePasswordComponent";
import AppointmentCalendar from "../AppointmentCalendar/AppointmentCalendar"
import Jobs from "../Jobs/jobs"
import SignDocument from "../SignDocument/SignDocument"
import DiscountPlanAdmin from "../DiscountPlans/planAdmin"
import PatientHistory from "../PatientComponents/History"
import Appointments from "../PatientComponents/Appointments"
import PatientDiscountPlan from "../PatientComponents/PatientDiscountPlan"
import ServiceDetails from "../PatientComponents/Scheduling/ServiceDetails"
import ServiceDays from "../PatientComponents/Scheduling/ServiceDays"
import Scheduling from "../PatientComponents/Scheduling/Scheduling"
import PatientForms from "../PatientComponents/Forms"
import PatientPayments from "../PatientComponents/Payments"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPen} from "@fortawesome/free-solid-svg-icons";
import ActionBar from "../ActionBar/ActionBar";
import {Routes, Route, useLocation} from "react-router-dom";

import "./MainComponent.css";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Flex,
  Button,
  Input,
  FormControl,
  FormLabel,
  VStack,
  RadioGroup,
  HStack,
  Avatar,
  IconButton,
  Radio,
  Switch,
  useToast,
  useColorMode,
  Text,
  Link,
  Box,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription
} from "@chakra-ui/react";

const outreachConfig = ()=>{
  const configuration = [
    {
      title: 'Using Responsible Party Contacts',
      description: 'These are the configrations related to the communicaitons with people who have guardians.',
      inputs: [
        {
          type : 'input',
          name: 'Max Age of Dependents',
          pattern : /^\d{1,2}$/,
          id : 'responsible_party_end_age'
        },
        {
          type: 'radio',
          id: 'responsible_party_communication',
          options: [
            { label: 'Allow use of contact information on patient record if responsible party contact information is invalid', value: 'use_patient_if_rp_invalid' },
            { label: 'Never use contact information on patient record even if responsible party contact information is invalid', value: 'use_only_rp' },
            { label: 'Never use responsible party contacts', value: 'always_use_patient' },
          ],
        }
      ],
    },
    {
      title: 'Family Grouping',
      description: 'Works only with the {{.GroupAppointments}} placeholder for emails and overrides Call reduction for phone calls.',
      inputs: [
        {
          type: 'switch',
          id: 'family_grouping_enabled',
          name: 'Group same day appts into one message if RP and patient share the same information',
        }
      ],
    },
    {
      title : 'Enable Overlap protection for Automated and Manual Campaigns',
      description : 'Which type of campaigns should we enable overlap protection for.',
      inputs : [{
        type: 'select',
        isMulti: true,
        id: 'campaign_overlap_protection',
        name: '',
        options: [
          { label: 'Reminder', value: 'reminder' },
          { label: 'Manual', value: 'campaign-manual' },
          { label: 'Birthday', value: 'campaign-birthday' },
          { label: 'Welcome', value: 'campaign-welcome' },
        ],
      },
      ]
    },{
      title : 'Group Appointment placeholder for Confirmation Campaigns',
      description : '',
      inputs : [
        {
          type : 'switch',
          id : 'include_all_future_appointments_in_confirmation',
          name : 'Include all future appointments in confirmation'
        }
      ]
    }
  ];
  return (
  <Box
    p={4}
    overflowY="auto"
    maxHeight="100vh"
    width="100%"
    position="relative"
  >
    <GenericSettings configuration={configuration} endpoint={'/settings/campaigns'}/>
    </Box>
  )
}

const WrapScheduling = ()=>{
  return (
  <Box
    p={4}
    overflowY="auto"
    maxHeight="100vh"
    width="100%"
    position="relative"
    >
    <Scheduling />
    </Box>
  )
}

const WrapServiceDetails = ()=>{
  return (
  <Box
    p={4}
    overflowY="auto"
    maxHeight="100vh"
    width="100%"
    position="relative"
    >
    <ServiceDetails />
    </Box>
  )
}

const WrapServiceDays = ()=>{
  return (
  <Box
    p={4}
    overflowY="auto"
    maxHeight="100vh"
    width="100%"
    position="relative"
    >
    <ServiceDays />
    </Box>
  )
}

const LeadSettings = ()=>{
  const configuration=[
    {
      title : 'Lead Tracking',
      description : 'Settings are related to how leads are tracked. Leads are when we detect that somebody who is not an existing patient is contacting your practice over any channel.',
      inputs : [
        {
          type : 'select',
          isMulti : false,
          id : 'conversion_rule',
          name : 'Select the rule that defines who should be considered a new patient',
          options : [
            {
              label : 'Existing patients with last appointments before 18 months ago or within the last 14 days onward (or no appointments in the past) are considered new patients',
              value : 0
            },
            {
              label : 'Existing patients with last appointments before 18 months ago (or no appointment in the past) and at least one in the future are considered new patients',
              value : 3
            },
            {
              label : 'Existing patients with last appointments within the last 14 days onward are considered new patients',
              value : 1
            },
            {
              label : 'Existing patients are the ones without any appointments in the past but an appointment in the future',
              value : 2
            },
          ]
        },{
          type : 'switch',
          name : 'Auto create campaigns on incoming calls',
          id : 'auto_create_on_incoming'
        },{
          type : 'switch',
          name : 'Auto create campaigns on visiting ols',
          id : 'auto_create_on_ols'
        }
      ]
    }
  ]
  return (
    <GenericSettings configuration={configuration} endpoint={'/settings/leads'} supportBatching={true}/>
  )
}

import {useAppContext} from "../../AppContext";
import TemplateEditor from "../TemplateEditor/TemplateEditor";

export default function MainComponent({isCollapsed, isMobile, toggleMenuCollapse, addActionBarItem, removeActionBarItem, actionBarItems}) {

  const {
    chatContext,
    setChatContext,
    isProfileOpen,
    setIsProfileOpen,
    chatSessionId,
    setChatSessionId,
    selectedBusiness,
    user,
    isPatient,
    handleDraftButtonClick,
    draft,
    isDraftBoxOpen,
    handleFormButtonClick,
    fileInputRef: contextFileRef,
    handleFileButtonClick
  } = useAppContext();

  const internalPages = {
    "/settings/adapter": Adapter,
    "/phones/numbers": PhoneNumbers,
    "/phones/blocked": BlockedPhone,
    "/phones/extensions": PhoneExtensions,
    "/settings/history" : HistoryTemplate,
    "/phones/routing": RoutesSetting,
    "/settings/notifications": NotificationSettings,
    "/settings/discount-plans" : DiscountPlanAdmin,
    "/notifications": NotificationSettings,
    "/settings/booking": BookingSettings,
    "/reports/calls": CallList,
    "/settings/subscription": Subscription,
    "/settings/users": UserManagement,
    "/locations": AllCustomers,
    "/jobs" : Jobs,
    "/template-editor": TemplateEditor,
    "/bundles" : Bundles,
    "/inbox": Inbox,
    "/tasks": Inbox,
    "/settings/stripe" : StripeConnect,
    "/reports/payments" : PaymentList,
    "/reports/payment-requests" : PaymentRequestList,
    '/payments' : PatientPayments,
    "/reports/installments" : InstallmentReport,
    "/reports/discount" : DiscountReport,
    "/history" : PatientHistory,
    "/whitelist" : WhiteList,
    "/invoices" : Invoices,
    '/outreach' : Campaigns,
    '/settings/outreach' : outreachConfig,
    '/settings/widget' : Widget,
    '/settings/leads' : LeadSettings,
    '/settings/customize_ai': CustomizeAI,
    '/settings/information' : Information,
    '/settings/forms' : Forms,
    '/discount-plans' : PatientDiscountPlan,
    '/appointments' : Appointments,
    '/calendar' : AppointmentCalendar,
    '/forms' : PatientForms,
    "/" : Dashboard
  };

  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [name, setName] = useState(Auth.user ? Auth.user.name : "");
  const [phone, setPhone] = useState(Auth.user ? Auth.user.phone : null);
  const [email, setEmail] = useState(Auth.user ? Auth.user.email : null);
  const [phoneUpdated, setPhoneUpdated] = useState(false);
  const [emailUpdated, setEmailUpdated] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [originalPassword, setOriginalPassword] = useState("");
  const [password, setPassword] = useState("");
  const [passwordInvalid, setPasswordInvalid] = useState(false);
  const [dominantHand, setDominantHand] = useState(Auth.user ? Auth.user.dominantHand : "");
  const {colorMode, toggleColorMode} = useColorMode();
  const [localTheme, setLocalTheme] = useState({colorMode});
  const location = useLocation();
  const [profileImage, setProfileImage] = useState(Auth.user ? (Auth.user.profileImage || Auth.user.picture) : "");
  const fileInputRef = useRef(null);
  const toast = useToast();
  const actionBarRef = useRef(null);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileUrl = URL.createObjectURL(file);
      setProfileImage(fileUrl); // Display the temporary URL immediately
    }

    const formData = new FormData();
    formData.append("file", file);
    cqAPI.post("/upload", formData)
      .then(response => {
        if (response.type === "ok") {
          setProfileImage(`${HOST}${response.url}`); // Update the profile image URL after successful upload
          toast({
            title: "Profile image uploaded successfully.", status: "success", duration: 9000, isClosable: true,
          });
        } else {
          toast({
            title: "Error uploading profile image.",
            description: response.msg,
            status: "error",
            duration: 9000,
            isClosable: true,
          });
        }
      })
      .catch(error => {
        toast({
          title: "Error uploading profile image.",
          description: error.message,
          status: "error",
          duration: 9000,
          isClosable: true,
        });
      });
  };


  const renderInternalPage = (displayedInternalPage) => {
    const ComponentToRender = internalPages[displayedInternalPage];
    if (ComponentToRender) {
      return <ComponentToRender selectedBusiness={selectedBusiness}/>;
    }
    return null;
  };



  useEffect(() => {
    localStorage.setItem("chakra-ui-color-mode", colorMode);
  }, [colorMode]);

  useEffect(() => {
    if (user) {
      if (user.name) {
        setName(user.name);
      }
      if (user.phone) {
        setPhone(user.phone);
        setPhoneUpdated(false);
      }
      if (user.dominantHand) {
        setDominantHand(user.dominantHand);
      }
    }
  }, [user]);

  const getPatientInfo = async () => {
    const response = await cqAPI.get('/isloggedin')
    setName(response.data.user.name);
    setPhone(response.data.user.phone);
    setEmail(response.data.user.email);
    setPhoneUpdated(false);
    setEmailUpdated(false);
    setProfileImage(response.data.user.picture)
  }

  useEffect(() => {
    setShowPassword(false);
    setIsAlertVisible(false);
    setLocalTheme(colorMode);
    if (isProfileOpen && getParam('_uid')) {
      //get the information for the patientF
      getPatientInfo()
    } else {
      setName(Auth.user ? Auth.user.name : "");
      setPhone(Auth.user ? Auth.user.phone : "");
      setEmail(Auth.user ? Auth.user.email : "");
      setPhoneUpdated(false);
      setEmailUpdated(false);
      setProfileImage(Auth.user ? (Auth.user.profileImage || Auth.user.picture) : "");
    }
  }, [isProfileOpen]);

  useEffect(() => {
    setOriginalPassword("");
    setPassword("");
    setPasswordInvalid(false);
  }, [showPassword]);

  const showAlert = (message) => {
    setAlertMessage(message);
    setIsAlertVisible(true);
  }

  const processUpdate = (response) => {
    const {msg} = response;
    if (response.type === "ok") {
      Auth.storeUser({
        ...Auth.user, name: name, ...(phone || phoneUpdated ? {phone} : {}), dominantHand: dominantHand, picture: profileImage
      });
      if (response?.msg?.includes("email")){
        toast({
          title: "Success",
          description: response.msg,
          status: "success",
          duration: 9000,
          isClosable: true,
        });
      }
      setIsProfileOpen(false); // Close the modal after successful update
      console.log("Profile updated successfully");
    } else {
      showAlert(msg || "Profile update failed");
    }
  };

  async function updateProfile() {
    try {
      const response = await cqAPI.post("/profile", {
        name: name, ...(phone || phoneUpdated ? {phone} : {}), ...(emailUpdated ? { email } : {}), dominantHand: dominantHand, ...(password ? {originalPassword, password} : {}), picture: profileImage
      });

      processUpdate(response);
    } catch (error) {
      console.error("Error updating profile: ", error);
    }
  }

  const handleThemeChange = () => {
    toggleColorMode();
  }

  const handleClose = () => {
    if (localTheme !== colorMode) {
      toggleColorMode();
    }
    setIsProfileOpen(false);
  }

  const profileModal = (<Modal className="alert1" isOpen={isProfileOpen} onClose={() => setIsProfileOpen(false)}>
      <ModalOverlay />
      <ModalContent>
        {isAlertVisible && (
          <Box flex="1">
          <Alert status="error">
            <AlertIcon/>
              <AlertTitle>
                <Text casing="capitalize">Error</Text>
              </AlertTitle>
              <AlertDescription display="block">
                {alertMessage}
              </AlertDescription>
          </Alert>
          </Box>
        )}
        <ModalHeader>Update Profile</ModalHeader>
        <ModalCloseButton onClick={handleClose}/>
        <ModalBody>
          <VStack spacing={4}>
            <Flex align="center" w="full">
              <Box position="relative">
                <Avatar size="xl" src={profileImage}/>
                <IconButton
                  icon={<FontAwesomeIcon icon={faPen}/>}
                  position="relative"
                  size="sm"
                  onClick={() => fileInputRef.current.click()}
                />
                <Input
                  ref={fileInputRef}
                  type="file"
                  accept="image/*" // Only accept image files
                  onChange={handleFileUpload}
                  hidden
                />
              </Box>
              <Flex direction="column">
                <FormControl id="name" ml={4} flex="1">
                  <FormLabel>Name:</FormLabel>
                  <Input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </FormControl>
                  <FormControl id="phone" mt={4} ml={4} flex="1">
                    <FormLabel>Phone:</FormLabel>
                    <Input
                      type="number"
                      value={phone}
                      onChange={(e) => {
                        if (e.target.value !== phone) {
                          setPhoneUpdated(true);
                          setPhone(e.target.value);
                        }
                      }}
                    />
                  </FormControl>
                  <FormControl id="email" mt={4} ml={4} flex="1">
                    <FormLabel>Email:</FormLabel>
                    <Input
                      type="email"
                      value={email}
                      onChange={(e) => {
                        if (e.target.value !== email) {
                          setEmailUpdated(true);
                          setEmail(e.target.value);
                        }
                      }}
                    />
                  </FormControl>
                </Flex>
              </Flex>
            <Box width="100%" textAlign="right">
              <Link
                onClick={(e) => {
                  e.preventDefault();
                  setShowPassword(!showPassword);
                }}
              >
                {showPassword ? "Don't update password" : "Update password"}
              </Link>
            </Box>
            <ChangePasswordComponent
              isOriginalRequired
              isVisible={showPassword}
              onPasswordChange={setPassword}
              onOriginalPasswordChange={setOriginalPassword}
              onIsInvalidChange={setPasswordInvalid}
            />
            {!isPatient && (<FormControl as="fieldset">
              <FormLabel as="legend">Dominant Hand:</FormLabel>
              <RadioGroup onChange={setDominantHand} value={dominantHand}>
                <HStack spacing="24px">
                  <Radio value="left">Left</Radio>
                  <Radio value="right">Right</Radio>
                </HStack>
              </RadioGroup>
            </FormControl>)}
            {/* Theme Title */}
            <Text fontSize="md" alignSelf="start" mt={5} mb={2}>
              Theme
            </Text>
            {/* Theme Selector */}
            <Flex align="center" justify="start" w="full">
              <Text fontSize="sm" mr={2}>
                Light
              </Text>
              <Switch
                isChecked={colorMode === "dark"}
                onChange={handleThemeChange}
                colorScheme="blue"
              />
              <Text fontSize="sm" ml={2}>
                Dark
              </Text>
            </Flex>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button
            mr={3}
            onClick={updateProfile}
            isDisabled={passwordInvalid}
            bg={colorMode === "dark" ? "#F9F9FB" : "#154043"}
            color={colorMode === "dark" ? "black" : "white"}
            _hover={{bg: colorMode === "dark" ? "#E0E0E0" : "#123536"}}
            _active={{bg: colorMode === "dark" ? "#C8C8C8" : "#0e2a2a"}}
          >
            Update Profile
          </Button>
          <Button variant="ghost" onClick={() => handleClose()}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>);

  return (
    <Flex direction="column" className="main-wrapper">
      {isCollapsed && isMobile && 
        (<ActionBar 
          actionBarItems={actionBarItems}
          toggleMenuCollapse={toggleMenuCollapse} 
          isCollapsed={isCollapsed} 
          isMobile={isMobile}
        />)}
      
    <Routes key={location.search || "default"}>
      <Route
        path="/oracle"
        element={<ChatComponent
          chatContext={chatContext}
          setChatContext={setChatContext}
          chatSessionId={chatSessionId}
          setChatSessionId={setChatSessionId}
          selectedBusiness={selectedBusiness}
        />}
      />
      <Route
        path="/patient/:patientId"
        element={<ChatComponent
          chatContext={chatContext}
          setChatContext={setChatContext}
          chatSessionId={chatSessionId}
          setChatSessionId={setChatSessionId}
          selectedBusiness={selectedBusiness}
        />}
      />
      <Route
        path="/po"
        element={<ChatComponent
          chatContext={chatContext}
          setChatContext={setChatContext}
          chatSessionId={chatSessionId}
          setChatSessionId={setChatSessionId}
          selectedBusiness={selectedBusiness}
        />}
      />
      <Route
        path="/history/:sessionId"
        element={<ChatComponent
          chatContext={chatContext}
          setChatContext={setChatContext}
          chatSessionId={chatSessionId}
          setChatSessionId={setChatSessionId}
          selectedBusiness={selectedBusiness}
        />}
      />
      <Route
        path="/sign/:request_id"
        element={<SignDocument/>}
      />
      <Route path="/calls/:callId" element={<CallDetail/>}/>
      <Route path="/inbox/:uid" element={<InboxMessages isMobile={isMobile} addActionBarItem={addActionBarItem} removeActionBarItem={removeActionBarItem}/>}/>
      <Route path="/tasks/:uid" element={<InboxMessages isMobile={isMobile} addActionBarItem={addActionBarItem} removeActionBarItem={removeActionBarItem}/>}/>

      <Route path="/appointments/new" element={<WrapScheduling/>}/>
      <Route path="/appointments/new/service/:serviceId" element={<WrapServiceDetails/>}/>
      <Route path="/appointments/new/service/:serviceId/:date" element={<WrapServiceDays/>}/>

      <Route path="/settings/history/:template_id" element={<EditHistoryTemplate/>}/>
      <Route path="/password_change" element={<ChangePassword/>}/>
      {Object.keys(internalPages).map((route) => (
        <Route key={route} path={route} element={renderInternalPage(route)}/>))}
    </Routes>

        {profileModal}
      </Flex>
);
}
